module.exports = __webpack_public_path__ + "img/Line.eac0d226.svg";